// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2I2d-","choiceBoxes":"toolbarselects_choiceBoxes__2PMk0","simpleField":"toolbarselects_simpleField__3uDNn"};